import { z } from 'zod';
// Anexo A de la spec técnica: catálogos cerrados. Mismo texto que los CHECK de la base.
export const FuenteMaestro = z.enum(['sap_ec', 'sap_hcm', 'suel2', 'propio']);
export const TipoContrato = z.enum(['indefinido', 'plazo_fijo', 'temporada', 'por_obra']);
export const TipoSociedad = z.enum(['principal', 'contratista']);
export const SistemaNomina = z.enum(['sap_ecp', 'sap_hcm', 'suel2', 'excel', 'ninguno']);
export const ModoIntegracion = z.enum(['api', 'archivo', 'manual']);
export const ModalidadLabor = z.enum(['trato', 'dia', 'hora', 'mixta']);
export const TipoCalculo = z.enum(['tarifa_unitaria', 'dia', 'hora', 'dia_meta']);
export const TipoConcepto = z.enum(['trato', 'dia', 'hora', 'bono', 'castigo']);
export const EstadoEvento = z.enum(['pendiente', 'validado', 'aprobado', 'cuarentena', 'anulado', 'rechazado']);
export const EstadoPeriodo = z.enum([
    'abierto',
    'en_calculo',
    'calculado',
    'revision_campo',
    'aprobacion_contratistas',
    'aprobado',
    'enviado_nomina',
    'cerrado',
]);
export const EstadoMovimiento = z.enum(['generado', 'enviado_a_nomina', 'acusado', 'rechazado_nomina', 'pagado']);
export const Calidad = z.enum(['aceptada', 'castigada', 'rechazada']);
export const MetodoIdentificacion = z.enum(['qr', 'nfc', 'rut_manual']);
export const Canal = z.enum(['whatsapp', 'sms', 'email', 'in_app', 'push', 'impreso']);
export const FuenteEvento = z.enum(['app', 'carga_masiva', 'romana', 'web']);
export const MetodoReparto = z.enum(['partes_iguales', 'horas', 'ponderador']);
export const RolBase = z.enum(['administrador', 'jefe', 'trabajador']);
export const TipoUsuario = z.enum(['interno', 'externo', 'trabajador', 'servicio']);
export const Permiso = z.enum([
    'planillero',
    'capataz',
    'inspector_calidad',
    'aprobador_contratista',
    'mantenedor_tarifas',
    'aprobador_tarifas',
    'enrolador_dispositivos',
    'cierre_periodo',
    'carga_masiva',
    'remuneraciones',
    'auditor',
]);
export const AmbitoTarifario = z.enum(['sociedad', 'predio', 'cuartel', 'cuadrilla']);
export const TipoUbicacion = z.enum(['predio', 'cuartel', 'hilera']);
export const DestinoExport = z.enum(['sap_ecp', 'sap_hcm', 'suel2', 'excel', 'webhook']);
export const TipoBono = z.enum(['multiplicador', 'monto_adicional']);
export const CondicionBono = z.enum(['meta_individual', 'meta_cuadrilla', 'labor_focalizada']);
export const AlcanceRetroactivo = z.enum(['desde_publicacion', 'todo_el_periodo_abierto']);
export const EstadoBono = z.enum(['borrador', 'autorizado', 'publicado', 'vencido']);
export const CausalCuarentena = z.enum([
    'PERSONA_NO_ENCONTRADA',
    'SIN_VINCULO_VIGENTE',
    'PERSONA_EN_CONFLICTO',
    'UBICACION_INVALIDA',
    'SIN_TARIFA',
    'SOBRE_TOPE',
    'FUERA_DE_VENTANA',
    'DESFASE_RELOJ',
    'VELOCIDAD_IMPOSIBLE',
    'ALTA_PROVISIONAL',
    'ANULACION_INVALIDA',
]);
export const CodigoControl = z.enum([
    'JORNADA_SIN_VALIDAR',
    'CUARENTENA_ABIERTA',
    'REPARTO_INCOMPLETO',
    'SIN_VINCULO',
    'PERSONA_EN_CONFLICTO',
    'CONTRATISTA_REGISTRO_VENCIDO',
    'HORAS_SOBRE_MAXIMO',
    'RECLAMO_ABIERTO',
    'CONCEPTO_INCOMPLETO',
    'BONO_NO_AUTORIZADO',
    'EXCEPCION_SIN_APROBAR',
    'TARIFA_AMBIGUA',
    'MOVIMIENTOS_DESCUADRADOS',
    'ACUSE_TARIFARIO_PENDIENTE',
]);
//# sourceMappingURL=enums.js.map